import { AsistenciasVivas } from "./AsistenciasVivas/AsistenciasVivas";
import { AsistenciasPorConfirmar } from "./AsistenciasPorConfirmar/AsistenciasPorConfirmar";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { GetProveedorInfo } from "../../context/actions/proveedorInfoActions";

export const Home2 = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(GetProveedorInfo());
  }, [dispatch]);

  return (
    <>

      <AsistenciasPorConfirmar />
      <AsistenciasVivas />
    </>
  );
};
